module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1041-ec9819de48ed9e9134918f5d74bcc847.png";